import React from 'react';
import { organizeModeOf } from '@cotera/api';
import { LibraryOrganizeDraftPanel } from '@cotera/client/app/v1/folder/library-organize-draft-panel';
import type { ArtifactRendererProps } from './types';
import { registerArtifactRenderer } from './registry';

/**
 * Artifact renderer for the coco-first organize flow. Renders the review bound
 * to the SHARED per-conversation draft, so the panel and Coco's draft tools see
 * and edit the same staged plan. Nothing is real until "Move".
 */
const OrganizeArtifactRenderer: React.FC<ArtifactRendererProps> = ({
  artifact,
  onClose,
}) => {
  const payload = artifact.payload as { conversationId?: string } | null;
  const conversationId = payload?.conversationId ?? '';
  return (
    <div className="h-full w-full bg-card">
      <LibraryOrganizeDraftPanel
        conversationId={conversationId}
        mode={organizeModeOf(artifact.payload)}
        onApplied={onClose}
      />
    </div>
  );
};

registerArtifactRenderer('organize-library', OrganizeArtifactRenderer);
